<template>
  <div class="card-gen-container">
    <el-card class="card-gen-card">
      <h2 class="card-gen-title">卡密生成（仅管理员）</h2>
      <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" style="margin-bottom:16px" />
      <el-form :inline="true" :model="form" @submit.native.prevent="onGen">
        <el-form-item label="卡密类型">
          <el-select v-model="form.vip_type" placeholder="请选择类型" style="width: 140px">
            <el-option label="周卡" value="week" />
            <el-option label="月卡" value="month" />
            <el-option label="季卡" value="quarter" />
            <el-option label="年卡" value="year" />
          </el-select>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number v-model="form.count" :min="1" :max="100" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onGen" :loading="loading">生成</el-button>
          <el-button v-if="cards.length" @click="exportTxt" style="margin-left:8px">导出txt</el-button>
        </el-form-item>
      </el-form>
      <el-table v-if="cards.length" :data="cards" border stripe style="width: 100%; margin-top: 24px;" :fit="true">
        <el-table-column prop="card_code" label="卡密">
          <template slot-scope="scope">
            <el-input v-model="scope.row.card_code" readonly size="mini" style="width: 90%" />
            <el-button type="text" size="mini" @click="copyCard(scope.row.card_code)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-divider v-if="history.length" content-position="left">生成历史</el-divider>
      <el-table v-if="history.length" :data="history" border stripe style="width: 100%; margin-top: 8px;" :fit="true">
        <el-table-column prop="card_code" label="卡密" min-width="220" />
        <el-table-column prop="vip_type" label="类型" width="80" />
        <el-table-column prop="is_used" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_used ? 'info' : 'success'">{{ scope.row.is_used ? '已使用' : '未使用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="生成时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.create_time) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CardGen',
  data() {
    return {
      form: {
        vip_type: '',
        count: 1
      },
      cards: [],
      loading: false,
      error: '',
      history: []
    }
  },
  created() {
    this.checkAdmin();
    this.fetchHistory();
  },
  methods: {
    async checkAdmin() {
      try {
        const res = await this.$axios.get('/user/info', { headers: this.authHeader() });
        if (!res.data || res.data.code !== 200 || res.data.data.role !== 'admin') {
          this.$message.error('仅管理员可访问');
          this.$router.replace('/');
        }
      } catch {
        this.$message.error('仅管理员可访问');
        this.$router.replace('/');
      }
    },
    async fetchHistory() {
      try {
        // 假设后端支持 /user/card_history
        const res = await this.$axios.get('/user/card_history', { headers: this.authHeader() });
        if (res.data && res.data.code === 200) {
          this.history = res.data.data || [];
        }
      } catch {}
    },
    async onGen() {
      if (!this.form.vip_type) {
        this.$message.warning('请选择卡密类型');
        return;
      }
      this.loading = true;
      this.error = '';
      try {
        const res = await this.$axios.post('/user/gen_card', this.form, { headers: this.authHeader() });
        if (res.data && res.data.code === 200) {
          this.cards = (res.data.cards || []).map(card_code => ({ card_code }));
          this.$message.success('生成成功');
          this.fetchHistory();
        } else {
          this.error = res.data.message || '生成失败';
        }
      } catch (e) {
        this.error = e.response?.data?.message || '网络错误';
      } finally {
        this.loading = false;
      }
    },
    exportTxt() {
      const txt = this.cards.map(c => c.card_code).join('\n');
      const blob = new Blob([txt], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'cards.txt';
      a.click();
      URL.revokeObjectURL(url);
    },
    copyCard(card) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(card).then(() => {
          this.$message.success('已复制到剪贴板');
        });
      } else {
        const input = document.createElement('input');
        input.value = card;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$message.success('已复制到剪贴板');
      }
    },
    formatDate(val) {
      if (!val) return '';
      const d = new Date(val);
      const pad = n => n.toString().padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    authHeader() {
      const token = localStorage.getItem('token');
      return token ? { Authorization: 'Bearer ' + token } : {};
    }
  }
}
</script>

<style scoped>
.card-gen-container {
  max-width: 600px;
  margin: 32px auto;
}
.card-gen-card {
  padding: 24px 24px 8px 24px;
}
.card-gen-title {
  text-align: center;
  margin-bottom: 24px;
  font-weight: 500;
}
</style> 